export default {
"La Palma de Cervelló": "08905",
"Sant Ferriol": "17162",
"L'Escala": "17062",
"Avinyonet del Penedès": "08013",
"Terrassa": "08279",
"Lloret de Mar": "17095",
"Campelles": "17037",
"Les Planes d'Hostoles": "17133",
"Masquefa": "08119",
"Guixers": "25111",
"Canovelles": "08041",
"Olot": "17114",
"Palafrugell": "17117",
"Santa Cristina d'Aro": "17181",
"Calaf": "08031",
"Gualba": "08097",
"Sant Just Desvern": "08221",
"Santa Margarida i els Monjos": "08251",
"Vilassar de Dalt": "08214",
"Colera": "17054",
"Les Llosses": "17096",
"Santa Pau": "17184",
"Solsona": "25207",
"Biosca": "25055",
"Massoteres": "25132",
"Juneda": "25119",
"Puiggròs": "25180",
"Cervera": "25072",
"Arenys de Mar": "08006",
"Vilobí del Penedès": "08304",
"Montblanc": "43086",
"Gelida": "08091",
"Perafita": "08160",
"Castellnou de Bages": "08062",
"Alcanar": "43004",
"El Cogul": "25076",
"El Soleràs": "25206",
"La Granadella": "25101",
"Torelló": "08285",
"Sant Andreu de la Barca": "08196",
"Blanes": "17023",
"Canet d'Adri": "17040",
"Camarasa": "25062",
"Torrebesses": "25226",
"La Vall de Boí": "25043",
"El Vilosell": "25253",
"Fontcoberta": "17071",
"Sant Gregori": "17163",
"Sant Boi de Llobregat": "08200",
"Sant Jaume de Frontanyà": "08216",
"Sant Vicenç de Montalt": "08264",
"Sant Vicenç de Torelló": "08265",
"Santa Maria de Besora": "08253",
"Vallcebre": "08293",
"Vallirana": "08295",
"Viladecans": "08301",
"Vilaller": "25245",
"L'Albi": "25009",
"Arbeca": "25029",
"La Sénia": "43044",
"Gombrèn": "17080",
"Campins": "08039",
"Martorelles": "08115",
"Vilanova del Vallès": "08902",
"Tivissa": "43150",
"Castell-Platja d'Aro": "17048",
"Palamós": "17118",
"Riudaura": "17149",
"La Guingueta d'Àneu": "25903",
"Vilanova i la Geltrú": "08307",
"Rupit i Pruit": "08901",
"Roda de Ter": "08183",
"Sant Agustí de Lluçanès": "08195",
"Santpedor": "08192",
"Vilafranca del Penedès": "08305",
"Olost": "08149",
"Piera": "08161",
"El Pla del Penedès": "08164",
"Guardiola de Berguedà": "08099",
"Sant Pere Sallavinera": "08189",
"Els Hostalets de Pierola": "08162",
"Alp": "17006",
"Sant Julià de Cerdanyola": "08903",
"Llançà": "17092",
"Roses": "17152",
"Sant Pere Pescador": "17178",
"Sant Llorenç d'Hortons": "08222",
"Òdena": "08143",
"La Pobla de Claramunt": "08165",
"Rubió": "08185",
"Vilanova del Camí": "08302",
"L'Ametlla del Vallès": "08005",
"Arenys de Munt": "08007",
"Sant Mateu de Bages": "08229",
"Sitges": "08270",
"El Masnou": "08118",
"Àger": "25002",
"Les Borges Blanques": "25058",
"Balsareny": "08018",
"Cabrils": "08030",
"Aguilar de Segarra": "08002",
"Navàs": "08141",
"Veciana": "08297",
"Castellcir": "08055",
"Castelló d'Empúries": "17047",
"Esponellà": "17065",
"Vilademuls": "17218",
"Banyoles": "17015",
"El Port de la Selva": "17140",
"Lles de Cerdanya": "25127",
"Sant Jaume de Llierca": "17165",
"Sant Miquel de Campmajor": "17174",
"Vidrà": "17212",
"Les Preses": "17139",
"El Bruc": "08025",
"Cabrera d'Anoia": "08028",
"Les Valls de Valira": "25239",
"Alt Àneu": "25024",
"La Torre de Cabdella": "25227",
"Sant Carles de la Ràpita": "43136",
"La Baronia de Rialb": "25042",
"Castellolí": "08063",
"Granyena de les Garrigues": "25105",
"Els Omellons": "25153",
"Camós": "17035",
"Mieres": "17105",
"Ogassa": "17112",
"Sant Feliu de Pallerols": "17161",
"Sant Martí de Llémena": "17172",
"Santa Oliva": "43140",
"Sunyer": "25212",
"Tremp": "25234",
"Albinyana": "43002",
"Aiguamúrcia": "43001",
"Bellvei": "43024",
"Aldover": "43006",
"Altafulla": "43012",
"Benifallet": "43025",
"Forès": "43061",
"La Canonja": "43907",
"Castellvell del Camp": "43042",
"Constantí": "43047",
"Freginals": "43062",
"Móra d'Ebre": "43093",
"Rodonyà": "43132",
"Pontils": "43141",
"Riudecols": "43128",
"Sarral": "43142",
"La Secuita": "43144",
"Vallmoll": "43160",
"La Selva del Camp": "43145",
"Ulldecona": "43156",
"Vallclara": "43158",
"Vilanova d'Escornalbou": "43167",
"Llardecans": "25125",
"Maials": "25133",
"Puigverd d'Agramunt": "25181",
"Riu de Cerdanya": "25913",
"La Seu d'Urgell": "25203",
"Salàs de Pallars": "25190",
"Sant Guim de Freixenet": "25192",
"Fulleda": "25097",
"Vinaixa": "25255",
"Maldà": "25130",
"Senan": "43146",
"Llorenç del Penedès": "43074",
"Juià": "17087",
"Masarac": "17100",
"Riudarenes": "17148",
"Albanyà": "17003",
"Bescanó": "17020",
"La Bisbal d'Empordà": "17022",
"Boadella i les Escaules": "17029",
"Bolvir": "17024",
"Cervià de Ter": "17050",
"La Jonquera": "17086",
"Massanes": "17101",
"Vilobí d'Onyar": "17233",
"Meranges": "17099",
"Mont-ras": "17110",
"Sant Joan les Fonts": "17185",
"Sant Pau de Segúries": "17177",
"Urús": "17206",
"Vilamacolum": "17225",
"Bovera": "25056",
"Bellpuig": "25050",
"Bellvís": "25052",
"Benavent de Segrià": "25053",
"Les": "25121",
"Mollerussa": "25137",
"La Molsosa": "25136",
"Canejan": "25063",
"Coll de Nargó": "25077",
"Farrera": "25089",
"Isona i Conca Dellà": "25115",
"El Palau d'Anglesola": "25158",
"Ribera d'Ondara": "25905",
"Rosselló": "25189",
"El Poal": "25168",
"Sant Esteve de la Sarga": "25196",
"Sant Guim de la Plana": "25197",
"Sant Martí de Riucorb": "25902",
"Sarroca de Bellera": "25201",
"Soses": "25210",
"Talarn": "25215",
"Tàrrega": "25217",
"Térmens": "25220",
"Tornabous": "25225",
"Torrefarrera": "25228",
"Torrefeta i Florejacs": "25907",
"La Vansa i Fórnols": "25909",
"Rupià": "17153",
"Sant Joan de les Abadesses": "17167",
"La Masó": "43080",
"Maspujols": "43081",
"Foixà": "17068",
"Lladó": "17088",
"Madremanya": "17097",
"L'Albiol": "43003",
"L'Argentera": "43017",
"Capafonts": "43039",
"Sant Jordi Desvalls": "17166",
"Capçanes": "43040",
"El Catllar": "43043",
"Conesa": "43046",
"Montferri": "43089",
"El Perelló": "43104",
"Cornudella de Montsant": "43049",
"Sant Mori": "17176",
"Falset": "43055",
"Els Garidells": "43066",
"Sant Miquel de Fluvià": "17175",
"Horta de Sant Joan": "43071",
"Margalef": "43075",
"Masdenverge": "43078",
"El Pinell de Brai": "43106",
"La Riba": "43124",
"Sant Jaume dels Domenys": "43137",
"Vilabertran": "17214",
"Valls": "43161",
"Vilamalla": "17226",
"El Vendrell": "43163",
"Vespella de Gaià": "43164",
"Vinebre": "43177",
"Alcoletge": "25012",
"Menàrguens": "25134",
"Vilanova de la Barca": "25254",
"Abella de la Conca": "25001",
"Cava": "25071",
"Fondarella": "25093",
"Aitona": "25038",
"Almacelles": "25019",
"La Granja d'Escarp": "25102",
"Bellaguarda": "25170",
"Bossòst": "25059",
"Castelldans": "25067",
"Granyena de Segarra": "25104",
"Gavet de la Conca": "25098",
"Montferrer i Castellbò": "25140",
"Montoliu de Lleida": "25142",
"Montoliu de Segarra": "25141",
"Les Oluges": "25152",
"Pinós": "25167",
"El Pont de Bar": "25030",
"El Pont de Suert": "25173",
"Ponts": "25172",
"Preixens": "25177",
"Sarroca de Lleida": "25200",
"Tiurana": "25222",
"Torrelameu": "25231",
"Torres de Segre": "25232",
"Les Valls d'Aguilar": "25906",
"La Bisbal del Penedès": "43028",
"Arbolí": "43015",
"Creixell": "43050",
"Els Alamús": "25004",
"Albatàrrec": "25007",
"Algerri": "25015",
"L'Aldea": "43904",
"Alcover": "43005",
"L'Aleixar": "43007",
"Bràfim": "43034",
"Arnes": "43018",
"Bot": "43032",
"Caseres": "43041",
"Les Piles": "43105",
"Colldejou": "43045",
"Els Guiamets": "43070",
"Móra la Nova": "43094",
"El Montmell": "43090",
"Esterri de Cardós": "25087",
"Gósol": "25100",
"La Palma d'Ebre": "43099",
"Passanant i Belltall": "43101",
"El Pont d'Armentera": "43113",
"Torroja del Priorat": "43154",
"Pratdip": "43118",
"Querol": "43120",
"Rocafort de Queralt": "43130",
"Sant Jaume d'Enveja": "43902",
"Tivenys": "43149",
"Vallfogona de Riucorb": "43159",
"Gratallops": "43069",
"Els Pallaresos": "43100",
"El Lloar": "43072",
"Fornells de la Selva": "17073",
"Garrigoles": "17076",
"Pontós": "17136",
"Porqueres": "17137",
"Sant Andreu Salou": "17157",
"Mas de Barberans": "43077",
"El Pla de Santa Maria": "43108",
"La Pobla de Mafumet": "43109",
"Massalcoreig": "25131",
"Reus": "43123",
"Roda de Barà": "43131",
"Savallà del Comtat": "43143",
"Alió": "43010",
"Vilallonga del Camp": "43166",
"Vilanova de Prades": "43168",
"Vilaplana": "43169",
"Ivorra": "25114",
"Vila-rodona": "43170",
"La Vilella Baixa": "43174",
"Fontanilles": "17070",
"Albons": "17004",
"Anglès": "17008",
"Cistella": "17051",
"Regencós": "17144",
"Sant Feliu de Guíxols": "17160",
"Besalú": "17019",
"Espinelves": "17063",
"Darnius": "17060",
"Sant Julià del Llor i Bonmatí": "17903",
"Palol de Revardit": "17123",
"Planoles": "17134",
"Portbou": "17138",
"Quart": "17142",
"Setcases": "17192",
"Terrades": "17196",
"Vilopriu": "17232",
"Torroella de Fluvià": "17198",
"Tortellà": "17200",
"Viladasens": "17216",
"Vallfogona de Ripollès": "17170",
"Vilamaniscle": "17227",
"Lladorre": "25123",
"Benissanet": "43026",
"Cabra del Camp": "43036",
"Anglesola": "25027",
"Arres": "25031",
"Arsèguel": "25032",
"Cervià de les Garrigues": "25073",
"Estaràs": "25085",
"Esterri d'Àneu": "25086",
"Linyola": "25122",
"Llimiana": "25128",
"Miralcamp": "25135",
"Prullans": "25179",
"Rialp": "25183",
"La Sentiu de Sió": "25035",
"Sidamon": "25205",
"Vilagrassa": "25244",
"Tírvia": "25221",
"Perafort": "43103",
"Puigpelat": "43119",
"Agullana": "17001",
"Bàscara": "17016",
"Beuda": "17021",
"Cabanelles": "17031",
"Caldes de Malavella": "17033",
"Campllong": "17038",
"Cornellà del Terri": "17056",
"Espolla": "17064",
"El Far d'Empordà": "17005",
"Figueres": "17066",
"Flaçà": "17067",
"Fontanals de Cerdanya": "17069",
"Forallac": "17902",
"Garrigàs": "17075",
"Ger": "17078",
"Guils de Cerdanya": "17082",
"Hostalric": "17083",
"Isòvol": "17084",
"Llanars": "17091",
"Maçanet de Cabrenys": "17102",
"Mollet de Peralada": "17106",
"Palau de Santa Eulàlia": "17119",
"Rabós": "17143",
"Sarrià de Ter": "17186",
"Saus, Camallera i Llampaies": "17187",
"La Tallada d'Empordà": "17195",
"Ventalló": "17210",
"Vilallonga de Ter": "17224",
"Vilanant": "17228",
"Botarell": "43033",
"Talavera": "25216",
"Els Torms": "25224",
"Mont-roig del Camp": "43092",
"Artesa de Lleida": "25033",
"Barbens": "25041",
"Bellmunt d'Urgell": "25049",
"Alàs i Cerc": "25005",
"Alcarràs": "25011",
"Cabanabona": "25060",
"Clariana de Cardener": "25075",
"Estamariu": "25088",
"Ivars d'Urgell": "25113",
"Llavorsí": "25126",
"Lleida": "25120",
"Els Omells de na Gaia": "25154",
"Pinell de Solsonès": "25166",
"Prats i Sansor": "25175",
"Llobera": "25129",
"Oliola": "25150",
"Olius": "25151",
"Sanaüja": "25191",
"Tarroja de Segarra": "25219",
"Torre-serona": "25233",
"Vallfogona de Balaguer": "25240",
"Sales de Llierca": "17154",
"Puigverd de Lleida": "25182",
"Bonastre": "43030",
"Banyeres del Penedès": "43020",
"Barberà de la Conca": "43021",
"La Bisbal de Falset": "43027",
"Cabacés": "43035",
"Calafell": "43037",
"Cunit": "43051",
"La Fatarella": "43056",
"La Figuera": "43058",
"Flix": "43060",
"Ginestar": "43067",
"Masllorenç": "43079",
"El Molar": "43085",
"Paüls": "43102",
"Mont-ral": "43091",
"La Morera de Montsant": "43096",
"La Pobla de Montornès": "43111",
"Porrera": "43114",
"Rasquera": "43121",
"Renau": "43122",
"Salomó": "43135",
"La Torre de l'Espanyol": "43152",
"Vilalba dels Arcs": "43175",
"Poboleda": "43112",
"Montornès de Segarra": "25143",
"Vandellòs i l'Hospitalet de l'Infant": "43162",
"Crespià": "17058",
"Puigcerdà": "17141",
"Serinyà": "17190",
"Cambrils": "43038",
"Salou": "43905",
"Amposta": "43014",
"Tarragona": "43148",
"L'Ametlla de Mar": "43013",
"L'Ampolla": "43906",
"Vila-seca": "43171",
"Alcanó": "25010",
"Ordis": "17115",
"Albesa": "25008",
"Maià de Montcal": "17098",
"Torroella de Montgrí": "17199",
"Alforja": "43009",
"L'Espluga de Francolí": "43054",
"Figuerola del Camp": "43059",
"Roquetes": "43133",
"Avinyonet de Puigventós": "17012",
"Begur": "17013",
"Alfarràs": "25013",
"Verges": "17211",
"Bordils": "17025",
"Borrassà": "17026",
"Castellfollit de la Roca": "17046",
"La Pobla de Segur": "25171",
"Pardines": "17125",
"Bellcaire d'Urgell": "25047",
"Baix Pallars": "25039",
"Es Bòrdes": "25057",
"Corbins": "25078",
"La Coma i la Pedra": "25163",
"L'Espluga Calba": "25081",
"Josa i Tuixén": "25910",
"Juncosa": "25118",
"Oliana": "25149",
"Organyà": "25155",
"La Pobla de Cérvoles": "25169",
"Soriguera": "25208",
"Tarrés": "25218",
"Vielha e Mijaran": "25243",
"Vilanova de Bellpuig": "25248",
"Vilanova de l'Aguda": "25249",
"Vila-sana": "25252",
"Ciutadilla": "25074",
"La Fuliola": "25096",
"Corbera d'Ebre": "43048",
"Duesaigües": "43053",
"Gandesa": "43064",
"Santa Coloma de Queralt": "43139",
"Godall": "43068",
"Llorac": "43073",
"La Nou de Gaià": "43097",
"Prades": "43116",
"Solivella": "43147",
"Riudecanyes": "43127",
"Riudoms": "43129",
"El Rourell": "43134",
"La Torre de Fontaubella": "43151",
"Vilabella": "43165",
"La Vilella Alta": "43173",
"Golmés": "25099",
"Nalec": "25145",
"Navès": "25146",
"La Pera": "17130",
"Torrent": "17197",
"Vall-llobrega": "17209",
"Vilaür": "17222",
"Bellmunt del Priorat": "43023",
"Blancafort": "43029",
"Bell-lloc d'Urgell": "25048",
"Amer": "17007",
"Biure": "17234",
"Arbúcies": "17009",
"Deltebre": "43901",
"Brunyola": "17028",
"Cantallops": "17041",
"Llívia": "17094",
"Montagut i Oix": "17109",
"Navata": "17111",
"Sant Feliu de Buixalleu": "17159",
"Sant Martí Vell": "17173",
"Santa Coloma de Farners": "17180",
"Serra de Daró": "17191",
"Viladrau": "17220",
"Les Borges del Camp": "43031",
"Foradada": "25094",
"Gimenells i el Pla de la Font": "25912",
"Granyanella": "25103",
"Agramunt": "25003",
"Almatret": "25020",
"Alpicat": "25023",
"Belianes": "25046",
"Castellar de la Ribera": "25064",
"Castellnou de Seana": "25068",
"Espot": "25082",
"Fígols i Alinyà": "25908",
"Montgai": "25138",
"Naut Aran": "25025",
"Ossó de Sió": "25157",
"Vallbona de les Monges": "25238",
"Vilanova de Segrià": "25251",
"Miravet": "43084",
"Montbrió del Camp": "43088",
"Ascó": "43019",
"Camarles": "43903",
"La Galera": "43063",
"El Milà": "43083",
"El Morell": "43095",
"La Pobla de Massaluca": "43110",
"Pradell de la Teixeta": "43115",
"Ulldemolins": "43157",
"Vilaverd": "43172",
"Vinyols i els Arcs": "43178",
"La Vall d'en Bas": "17207",
"Argelaguer": "17010",
"Ripoll": "17147",
"Campdevànol": "17036",
"Alins": "25017",
"Tortosa": "43155",
"La Cellera de Ter": "17189",
"Cadaqués": "17032",
"Calonge": "17034",
"Camprodon": "17039",
"Celrà": "17049",
"Cruïlles, Monells i Sant Sadurní de l'Heura": "17901",
"Das": "17061",
"Fortià": "17074",
"Garriguella": "17077",
"Palau-saverdera": "17120",
"Pau": "17128",
"Pedret i Marzà": "17129",
"Girona": "17079",
"Pont de Molins": "17135",
"Ribes de Freser": "17145",
"Riells i Viabrea": "17146",
"La Selva de Mar": "17188",
"Siurana": "17052",
"Sant Hilari Sacalm": "17164",
"Ullastret": "17205",
"La Vall de Bianya": "17208",
"Vilablareix": "17215",
"Llambilles": "17090",
"Breda": "17027",
"L'Armentera": "17011",
"Colomers": "17055",
"Cabanes": "17030",
"Capmany": "17042",
"Corçà": "17057",
"Llagostera": "17089",
"Llers": "17093",
"Peralada": "17132",
"Queralbs": "17043",
"Riumors": "17151",
"Salt": "17155",
"Sant Aniol de Finestres": "17183",
"Sant Climent Sescebes": "17158",
"Sant Joan de Mollet": "17168",
"Sant Julià de Ramis": "17169",
"Susqueda": "17194",
"Toses": "17201",
"Ullà": "17204",
"Vilafant": "17221",
"Vilajuïga": "17223",
"Vila-sacra": "17230",
"L'Albagés": "25006",
"Aspa": "25036",
"Cabó": "25061",
"Castellserà": "25070",
"La Floresta": "25092",
"Guimerà": "25109",
"Ivars de Noguera": "25112",
"Montellà i Martinet": "25139",
"Sudanell": "25211",
"Torà": "25223",
"Torregrossa": "25230",
"Os de Balaguer": "25156",
"Els Plans de Sió": "25911",
"La Portella": "25174",
"Verdú": "25242",
"Ribera d'Urgellet": "25185",
"Riner": "25186",
"Sant Ramon": "25194",
"Seròs": "25204",
"Sort": "25209",
"Artesa de Segre": "25034",
"Alfara de Carles": "43008",
"Almoster": "43011",
"L'Arboç": "43016",
"La Febró": "43057",
"Batea": "43022",
"Garcia": "43065",
"Marçà": "43076",
"El Masroig": "43082",
"Nulles": "43098",
"Pira": "43107",
"Prat de Comte": "43117",
"Riba-roja d'Ebre": "43125",
"La Riera de Gaià": "43126",
"Santa Bàrbara": "43138",
"Torredembarra": "43153",
"Xerta": "43052",
"Vimbodí i Poblet": "43176",
"La Vajol": "17014",
"Aiguaviva": "17002",
"Bellcaire d'Empordà": "17018",
"Maçanet de la Selva": "17103",
"Cassà de la Selva": "17044",
"Gualta": "17081",
"Jafre": "17085",
"Molló": "17107",
"Osor": "17116",
"Palau-sator": "17121",
"Pals": "17124",
"Parlavà": "17126",
"Riudellots de la Selva": "17150",
"Sant Llorenç de la Muga": "17171",
"Santa Llogaia d'Àlguema": "17182",
"Sils": "17193",
"Tossa de Mar": "17202",
"Ultramort": "17203",
"Vidreres": "17213",
"Viladamat": "17217",
"Guissona": "25110",
"Lladurs": "25124",
"Almenar": "25021",
"Preixana": "25176",
"Sant Llorenç de Morunys": "25193",
"Senterada": "25202",
"Alfés": "25014",
"Alguaire": "25016",
"Alòs de Balaguer": "25022",
"Bausen": "25045",
"Les Avellanes i Santa Linya": "25037",
"Balaguer": "25040",
"Bassella": "25044",
"Bellver de Cerdanya": "25051",
"Castell de Mur": "25904",
"Castelló de Farfanya": "25069",
"Conca de Dalt": "25161",
"Cubells": "25079",
"Odèn": "25148",
"Penelles": "25164",
"Peramola": "25165",
"Vall de Cardós": "25901",
"Vilamòs": "25247",
"Vilanova de Meià": "25250",
"El Papiol": "08158",
"Santa Maria de Martorelles": "08256",
"Figaró-Montmany": "08134",
"Gironella": "08092",
"La Llagosta": "08105",
"Abrera": "08001",
"Artés": "08010",
"Badia del Vallès": "08904",
"Begues": "08020",
"Berga": "08022",
"Bigues i Riells": "08023",
"Calders": "08034",
"Casserres": "08049",
"Calella": "08035",
"Callús": "08038",
"Castellar del Riu": "08050",
"Castellfollit del Boix": "08059",
"Cercs": "08268",
"Cornellà de Llobregat": "08073",
"Manresa": "08113",
"Martorell": "08114",
"Marganell": "08242",
"Montornès del Vallès": "08136",
"Les Masies de Voltregà": "08117",
"La Nou de Berguedà": "08142",
"Òrrius": "08153",
"Moià": "08138",
"Rellinars": "08179",
"Sant Adrià de Besòs": "08194",
"Sant Boi de Lluçanès": "08201",
"Sant Hipòlit de Voltregà": "08215",
"La Quar": "08177",
"Sant Julià de Vilatorta": "08220",
"Ripollet": "08180",
"Sant Martí de Centelles": "08224",
"Sant Sadurní d'Anoia": "08240",
"Sant Salvador de Guardiola": "08098",
"Santa Coloma de Cervelló": "08244",
"Santa Coloma de Gramenet": "08245",
"Santa Maria d'Oló": "08258",
"Tavertet": "08280",
"Tordera": "08284",
"Sant Vicenç de Castellet": "08262",
"Aiguafreda": "08014",
"Argentona": "08009",
"Calonge de Segarra": "08036",
"Castellgalí": "08061",
"Capellades": "08044",
"Castellterçol": "08064",
"Les Franqueses del Vallès": "08086",
"Monistrol de Montserrat": "08127",
"Montcada i Reixac": "08125",
"Orís": "08150",
"Pallejà": "08157",
"Sant Antoni de Vilamajor": "08198",
"Sant Climent de Llobregat": "08204",
"Sant Feliu de Llobregat": "08211",
"Sant Martí d'Albars": "08225",
"Santa Eugènia de Berga": "08246",
"Santa Maria de Palautordera": "08259",
"Santa Susanna": "08261",
"Subirats": "08273",
"Avià": "08011",
"Barberà del Vallès": "08252",
"Barcelona": "08019",
"Cabrera de Mar": "08029",
"El Brull": "08026",
"Les Cabanyes": "08027",
"Esplugues de Llobregat": "08077",
"Calldetenes": "08037",
"Cànoves i Samalús": "08042",
"Gallifa": "08087",
"Carme": "08048",
"Montesquiu": "08131",
"Castellbisbal": "08054",
"Castellfollit de Riubregós": "08060",
"Fígols": "08080",
"Gaià": "08090",
"Gavà": "08089",
"Granollers": "08096",
"Igualada": "08102",
"Olesa de Montserrat": "08147",
"Lluçà": "08109",
"Palau-solità i Plegamans": "08156",
"Montgat": "08126",
"Prats de Lluçanès": "08171",
"Montmajor": "08132",
"Els Prats de Rei": "08170",
"Premià de Dalt": "08230",
"Pujalt": "08176",
"Sant Esteve de Palautordera": "08207",
"Rajadell": "08178",
"Sant Joan de Vilatorrada": "08218",
"La Roca del Vallès": "08181",
"Tagamanent": "08276",
"Sabadell": "08187",
"Sant Esteve Sesrovires": "08208",
"Sant Fruitós de Bages": "08213",
"Sant Martí Sarroca": "08227",
"Sant Pol de Mar": "08235",
"Santa Fe del Penedès": "08249",
"Talamanca": "08277",
"Vacarisses": "08291",
"Vallgorguina": "08294",
"Vilanova de Sau": "08303",
"Cervelló": "08068",
"Puigdàlber": "08174",
"Argençola": "08008",
"Castellbell i el Vilar": "08053",
"Granera": "08095",
"Lliçà de Vall": "08108",
"Muntanyola": "08129",
"Muntanyola": "08129",
"Orpí": "08152",
"Mura": "08139",
"Olèrdola": "08145",
"Pontons": "08168",
"Sant Pere de Riudebitlles": "08232",
"El Prat de Llobregat": "08169",
"Puig-reig": "08175",
"Sant Martí de Tous": "08226",
"Tavèrnoles": "08275",
"Sant Sadurní d'Osormort": "08241",
"Teià": "08281",
"Seva": "08269",
"Taradell": "08278",
"Sant Quintí de Mediona": "08236",
"Tona": "08283",
"Matadepera": "08120",
"Mataró": "08121",
"Monistrol de Calders": "08128",
"Bellprat": "08021",
"Badalona": "08015",
"Balenyà": "08017",
"Caldes de Montbui": "08033",
"Caldes d'Estrac": "08032",
"Cubelles": "08074",
"Montmeló": "08135",
"L'Espunyola": "08078",
"Lliçà d'Amunt": "08107",
"Santa Maria de Corcó": "08254",
"Fonollosa": "08084",
"Gisclareny": "08093",
"El Pont de Vilomara i Rocafort": "08182",
"Saldes": "08190",
"Sant Cebrià de Vallalta": "08203",
"Sant Martí Sesgueioles": "08228",
"Sallent": "08191",
"Ullastrell": "08290",
"Sant Celoni": "08202",
"Vallbona d'Anoia": "08292",
"Sant Cugat del Vallès": "08205",
"Sant Pere de Torelló": "08233",
"Sant Quirze Safaja": "08239",
"Santa Eulàlia de Ronçana": "08248",
"Santa Maria de Merlès": "08255",
"Súria": "08274",
"Torrelles de Foix": "08288",
"Torrelles de Llobregat": "08289",
"Vilassar de Mar": "08219",
"Viver i Serrateix": "08308",
"Santa Perpètua de Mogoda": "08260",
"Molins de Rei": "08123",
"Sant Pere de Ribes": "08231",
"Sant Fost de Campsentelles": "08209",
"Tiana": "08282",
"Sant Quirze de Besora": "08237",
"Malla": "08111",
"Capolat": "08045",
"Sant Vicenç dels Horts": "08263",
"Cardedeu": "08046",
"Avinyó": "08012",
"Canyelles": "08043",
"Castell de l'Areny": "08057",
"Castellar de n'Hug": "08052",
"Castellar del Vallès": "08051",
"Collbató": "08069",
"Castelldefels": "08056",
"Centelles": "08067",
"Corbera de Llobregat": "08072",
"Sant Cugat Sesgarrigues": "08206",
"Fogars de Montclús": "08081",
"L'Hospitalet de Llobregat": "08101",
"Jorba": "08103",
"La Llacuna": "08104",
"Malgrat de Mar": "08110",
"Mediona": "08122",
"Mollet del Vallès": "08124",
"Montclar": "08130",
"Montmaneu": "08133",
"Olesa de Bonesvalls": "08146",
"Sagàs": "08188",
"Sant Feliu de Codines": "08210",
"Sant Andreu de Llavaneres": "08197",
"Santa Eulàlia de Riuprimer": "08247",
"Sentmenat": "08267",
"Sobremunt": "08271",
"Sora": "08272",
"La Torre de Claramunt": "08286",
"Vic": "08298",
"Vilada": "08299",
"Viladecavalls": "08300",
"Esparreguera": "08076",
"Bagà": "08016",
"Navarcles": "08140",
"Cardona": "08047",
"Castellet i la Gornal": "08058",
"Castellví de Rosanes": "08066",
"Collsuspina": "08070",
"L'Estany": "08079",
"Gurb": "08100",
"Les Masies de Roda": "08116",
"Olvan": "08144",
"Parets del Vallès": "08159",
"Oristà": "08151",
"Palafolls": "08155",
"La Pobla de Lillet": "08166",
"Polinyà": "08167",
"Sant Joan Despí": "08217",
"Sant Bartomeu del Grau": "08199",
"Sant Feliu Sasserra": "08212",
"Sant Llorenç Savall": "08223",
"Sant Quirze del Vallès": "08238",
"Santa Maria de Miralles": "08257",
"Vilalba Sasserra": "08306",
"Fogars de la Selva": "08082",
"La Granada": "08094",
"Sant Iscle de Vallalta": "08193",
"Font-rubí": "08085",
"Alella": "08003",
"Alpens": "08004",
"Borredà": "08024",
"Canet de Mar": "08040",
"Castellví de la Marca": "08065",
"Cerdanyola del Vallès": "08266",
"Copons": "08071",
"Dosrius": "08075",
"Folgueroles": "08083",
"La Garriga": "08088",
"Llinars del Vallès": "08106",
"Manlleu": "08112",
"Montseny": "08137",
"Olivella": "08148",
"Pacs del Penedès": "08154",
"Pineda de Mar": "08163",
"Premià de Mar": "08172",
"Rubí": "08184",
"Sant Pere de Vilamajor": "08234",
"Santa Cecília de Voltregà": "08243",
"Santa Margarida de Montbui": "08250",
"Torrelavit": "08287",
"Vallromanes": "08296"
}
